import { RailsReferralCode } from '@sls-react/typings/services/rails/user';
import fetcher, { makeFetcher } from '@sls-react/api/fetcher';
import { format } from 'date-fns';
import { BaseUserSearchFilterResponse } from '@sls-react/typings/services/rails/userSearchFilters';

export const fetchReferralInfo = makeFetcher<RailsReferralCode>(
  () => ({ uuid }) => `/v1/users/${uuid}/referral_code`,
);

export const putAmbassadorApply = () =>
  fetcher<any>(({ uuid }) => `/v1/users/${uuid}/ambassador`, {
    method: 'put',
  });

export const fetchReferralCodeByName = (name: string) =>
  fetcher<RailsReferralCode>(`/v1/referral_codes/${name}`, {
    ignoreErrors: true,
  });

export const putRoles = (roles: number[]) =>
  fetcher(({ uuid }) => `/iam/profile/v1/profiles/${uuid}`, {
    method: 'put',
    body: {
      roles,
    },
  });

export const postFavoriteSports = (categoryIds: number[]) =>
  fetcher('/v1/preferred_categories', {
    method: 'post',
    body: {
      preferred_category_ids: categoryIds,
    },
  });

export const postUploadAvatar = (file: File) => {
  const data = new FormData();
  data.append('avatar', file);

  return fetcher(({ uuid }) => `/v1/users/${uuid}/avatar`, {
    method: 'put',
    headers: {
      'content-type': null,
    },
    body: data,
  });
};

export const postStartVacation = (endDate: Date) =>
  fetcher(({ uuid }) => `/v1/users/${uuid}/vacations`, {
    method: 'post',
    body: {
      vacation: {
        started_at: format(new Date(), 'yyyy-MM-dd'),
        ended_at: format(new Date(endDate), 'yyyy-MM-dd'),
      },
    },
  });

export const endVacation = () =>
  fetcher(({ uuid }) => `/v1/users/${uuid}/active_vacation`, {
    method: 'delete',
  });

export const fetchUserSearchFilters = makeFetcher<BaseUserSearchFilterResponse>(
  () => '/v1/search_filters',
);

export const updateFastShipping = ({
  enabled,
  zip,
}: {
  enabled?: boolean;
  zip?: string;
}) =>
  fetcher('/v1/search_filters/fast_shipping', {
    method: 'put',
    params: {
      search_filter: {
        enabled,
        zip,
      },
    },
  });

export const updateCanadianSeller = ({ enabled }: { enabled?: boolean }) =>
  fetcher('/v1/search_filters/canadian_seller', {
    method: 'put',
    params: {
      search_filter: {
        enabled,
      },
    },
  });

export const reduceEnabledSearchFilters = (
  filters?: BaseUserSearchFilterResponse | null,
  fastShipping?: string | null,
  canadianSellers?: string | null,
) => {
  return {
    ...filters
      ?.filter(s => {
        if (!s.query) {
          return false;
        }

        if (s.slug === 'fast_shipping' && fastShipping === '1') {
          return true;
        }

        if (s.slug === 'canadian_seller' && canadianSellers === '1') {
          return true;
        }

        return false;
      })
      ?.reduce((p, c) => ({ ...p, ...c.query }), {}),
  };
};

export const deleteSelfUnrestrict = () =>
  fetcher(({ uuid }) => `/iam/v1/auth/user/${uuid}/restriction`, {
    method: 'delete',
  });
